import React, { useState } from "react";
import { Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import MeetingRoom from "./MeetingRoom";
import Vehicle from "./Vehicle";
import classnames from "classnames";

const Reservation = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle1 = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div>
      <Row style={{ display: "flex", alignItems: "center" }} className="mt-3">
        <Col xs={9}>
          <h5>
            ตารางแสดงการจองของท่าน
          </h5>
        </Col>
        <Col className="text-end">
        </Col>
      </Row>
      <div class="my-2" style={{ border: '2px solid rgb(58, 64, 205)' }}></div>
      <Nav
        pills
        className="navtab-bg mb-2"
        fill
      >
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: activeTab === "1",
            })}
            onClick={() => {
              toggle1("1");
            }}
          >
            รายการจองห้องประชุม
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: activeTab === "2",
            })}
            onClick={() => {
              toggle1("2");
            }}
          >
            รายการจองยานพาหนะ
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <MeetingRoom />
        </TabPane>
        <TabPane tabId="2">
          <Vehicle />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default Reservation;
